/**
 * baseStoragePaths.js — Storage tenant prefixes.
 *
 * Live uploads use `bases/{id}/…` only.
 */

export const BASE_STORAGE_PREFIX = 'bases';

const TENANT_PREFIX_RE = /^bases\/([^/]+)(?:\/|$)/;

function cleanKey(value) {
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * @param {string} baseKey
 * @param {string} relativePath - Path under the tenant root (no leading slash).
 * @returns {string}
 */
export function buildBaseStoragePath(baseKey, relativePath = '') {
  const key = cleanKey(baseKey);
  const relative = String(relativePath || '').replace(/^\/+/, '');
  if (!key) return relative;
  return relative ? `${BASE_STORAGE_PREFIX}/${key}/${relative}` : `${BASE_STORAGE_PREFIX}/${key}`;
}

/**
 * @param {string} path
 * @returns {boolean}
 */
export function isTenantStoragePath(path) {
  return TENANT_PREFIX_RE.test(String(path || '').replace(/^\/+/, ''));
}

/**
 * @param {string} path
 * @returns {string}
 */
export function resolveBaseKeyFromStoragePath(path) {
  const match = String(path || '').replace(/^\/+/, '').match(TENANT_PREFIX_RE);
  return match ? cleanKey(match[1]) : '';
}
